import React, { useState, useEffect } from 'react';

import { useSelector } from 'react-redux';
import { customerState } from '../store/slices/customer';
import { productState } from '../store/slices/product';
import { paymentState } from '../store/slices/payment';
import { tokenState } from '../store/slices/token';

import { useTranslation, Trans } from 'react-i18next';

import { useLottie, Lottie } from 'react-lottie-hook';
import animationData from '../assets/animation/loading';

import BasePage from './BasePage';
import { Button } from '../components';

import { postLeadData } from '../services/customer';
import { postFormData } from '../services/thankYou';
import { maskValue } from '../helpers/mask';

/**
* Final page of checkout
*/
const ThankYouPage = () => {
  const { t } = useTranslation('thankYou');
  const { customer } = useSelector(customerState);
  const { product } = useSelector(productState);
  const { payment } = useSelector(paymentState);
  const { token } = useSelector(tokenState);

  const paymentId = payment.paymentMethod?.value || 'credit_card';
  const { REACT_APP_CONTACT_EMAIL, REACT_APP_CONTACT_PHONE } = process.env;

  const [isLoading, setLoadingAs] = useState(true);
  const [response, setResponse] = useState({});

  const [lottieRef] = useLottie({
    renderer: 'svg',
    rendererSettings: { preserveAspectRatio: 'xMidYMid slice', progressiveLoad: false },
    animationData
  });

  useEffect(() => {
    postFormData({ customer, product, payment, token })
      .then((data) => {
        setResponse({status: "success", data});
        postLeadData({ ...customer, ...customer.address, conversionIdentifier: `finalizou_compra_${paymentId}` })
      })
      .catch((error) => {
        setResponse({status: "error", data : error})
        postLeadData({ ...customer, ...customer.address, conversionIdentifier: `erro_na_compra_${paymentId}` })
      })
      .finally(() => setLoadingAs(false));
  }, []);
  
  return (
    <BasePage>
      <div className={'page__container ' + (isLoading ? '' : 'page__container--hidden')}>
        <h1 className='page__title'>{t('processing')}</h1>
        <Lottie lottieRef={lottieRef} height={250} width={250} />
      </div>
      <div className={'page__container ' + (isLoading ? 'page__container--hidden' : '')}>
        <h1 className='page__title'>
          {t(`${response.status}.title`)}
        </h1>
        <p className='page__text'>
          <Trans
            t={t}
            i18nKey={`${response.status}.text.${paymentId}`}
            values={{ email: customer.email }}
          />
        </p>
        {
          response.status == 'success' && response?.data?.invoice?.length > 0 &&
          <p className='page__text'>
            <Button
              type='link'
              mode='primary'
              text='Baixar boleto'
              noMargin={true}
              url={response.data.invoice}
            />
          </p>
        }
        <p className='page__text'>
          {t(`${response.status}.contact`)}
          <br />
          <a href={`mailto:${REACT_APP_CONTACT_EMAIL}`} target='_blank' rel='noopener noreferrer'>
            {REACT_APP_CONTACT_EMAIL}
          </a>
          <br />
          <a href={`https://wa.me/55${REACT_APP_CONTACT_PHONE}`} target='_blank' rel='noopener noreferrer'>
            {maskValue('(00) 0000-00000', REACT_APP_CONTACT_PHONE)}
          </a>
        </p>
        <p className='page__text'>
          <Trans
            t={t}
            i18nKey={`${response.status}.farewell`}
          />
        </p>
      </div>
    </BasePage>
  );
}
export default ThankYouPage;